export const state = {
  data: [],
  options: []
}

export const getters = {
  countryData(state) {
    return countryData => state.data.find(cd => cd.key === countryData)
  },
  getTicketFlowCountryData(state) {
    const element = state.data.find(cd => {
      return cd.key === 'use_new_ticket_service'
    })
    return element
  },
  getTicketAutomationFlow(state) {
    const element = state.options.find(so => {
      return so.name === 'orderCompensationEnabled'
    })
    return element
  }
}

export const mutations = {
  SET_COUNTRY_DATA(state,
    data
  ) {
    state.data = data
  },
  SET_SUPPORT_OPTION(state,
    option
  ) {
    state.options.push(option)
  },
}

export const actions = {
  commitCountryData({
    commit
  }, countryData) {
    commit('SET_COUNTRY_DATA', countryData)
  },
  commitSupportOption({
    commit
  }, option) {
    commit('SET_SUPPORT_OPTION', option)
  },
}
